export default __webpack_public_path__ + "static/media/mobile_banner.af950662.jpg";